module.exports = __webpack_public_path__ + "images/emoji/guardsman.721f11432820903357a8.png";